import './AddGoal.css';
// import TimeConstraintSelection from '../components/TimeConstraintSelection.js'
import Selector from '../components/Selector.js'
import AddMilestone from './milestones/AddMilestone.js'
import Milestone from './milestones/Milestone.js'
import updateUserData from '../../assets/functions/updateUserData'
import React, {useState} from "react";

function EditGoal(props) {

    const [description, setDescription] = useState(props.activeGoal.title);
    const [goalType, setGoalType] = useState(props.activeGoal.goalType);
    const [milestones, setMilestones] = useState(props.activeGoal.milestones);
    const [isGlowGoal, setIsGlowGoal] = useState(props.activeGoal.isGlowGoal)
    const [projectId, setProjectId] = useState(props.activeGoal.projectId)

      const handleNoteChange = (event) => {
        setDescription(event.target.value);
      };

      function saveUpdatedGoal() {
        let indexToChange = props.userProfile.goals.indexOf(props.activeGoal)
        let updatedGoalsArray =[...props.userProfile.goals]
        updatedGoalsArray[indexToChange]={"goalType": goalType, "title": description, "milestones": milestones, "timeConstraintType": "", "timeConstraintTime": "",  "projectId": projectId, "isGlowGoal": isGlowGoal}
        updateUserData("updateGoal", updatedGoalsArray, props.userProfile, props.setUserProfile, props.setShowEditGoal)
      }

    return (
        <div className="addGoalOuterBlock">
          <p className="cancelText" onClick={() => props.setShowEditGoal(false)}> cancel</p>
            <div className="goalTypeRow">
              <p onClick={() => setGoalType("milestone")} className={goalType==="milestone" ? "goalType activeGoalType" : "goalType"}> milestone </p>
              <p onClick={() => setGoalType("routine")} className={goalType==="routine" ? "goalType activeGoalType" : "goalType"}> routine </p>
            </div>
            <div className="goalProjectSelector">
              <div className="addGoalProjectSelector">
            {!isGlowGoal &&
                <Selector data={projectId} setData={setProjectId} userProfile={props.userProfile} header="select associated project" type="projects" className="dropdownContainer"/>
              }
              {isGlowGoal &&
                <Selector data={projectId} setData={setProjectId} userProfile={props.userProfile} header="select associated project" type="glowGoals" className="dropdownContainer"/>
              }
              </div>
                <div className="goalGlowPower">
                    <p onClick={() => setIsGlowGoal(true)} className={isGlowGoal ? "glowPowerGoal activeGlowGoalButton" : "glowPowerGoal"}> glow </p>
                    <p onClick={() => setIsGlowGoal(false)} className={isGlowGoal ? "glowPowerGoal" : "glowPowerGoal activePowerGoalButton"}> power </p>
                </div>
            </div>
            <div className="goalDescriptionDiv">
                <p className="goalTextHeader">set goal description</p>
                <textarea
                    className="goalDescriptionInput"
                    type="text"
                    id="description"
                    value={description}
                    onChange={handleNoteChange}
                    name="description"
                    spellCheck="false"
                />
            </div>

            {goalType === "milestone" && 
              <div className="milestonesRowFlex">
                        {milestones.map((milestone, index) => (
                            <Milestone key={index} index={index} milestone={milestone}/>
                        ))}
                        <AddMilestone milestones={milestones} setMilestones={setMilestones}/>
                    </div>
            }
            {goalType === "routine" && 
              <div className="routineInput">
                <p> routine </p>
            </div>
            }
            {/* <p className="doneButtonAddGoal" onClick={async () => 
              {updateUserData("edit", 
                {"goalType": goalType, "title": description, "milestones": milestones, "timeConstraintType": "", "timeConstraintTime": "",  "projectId": projectId, "isGlowGoal": isGlowGoal},
                props.userProfile,
                props.setUserProfile,
                props.clearFormData
                )} }> edit goal</p> */}
            <p className="doneButtonAddGoal" onClick={async() => saveUpdatedGoal()} > save edited goal </p>
            <p className="doneButtonAddGoal" onClick={async() => updateUserData("deleteGoal", props.activeGoal, props.userProfile, props.setUserProfile, props.setShowEditGoal)}> delete goal </p>
        </div>
    )
}

export default EditGoal;